import React, { Fragment, useState, useEffect, useContext } from 'react';
import { ProjectContext } from '../../../../../context/Project';
import { FormGroup, Input, Label } from 'reactstrap';

function Description() {
    const { getDescription, setDescription } = useContext(ProjectContext);

    const [projectDescription, setProjectDescription] = useState('');
        
    useEffect(() => {
        let description = getDescription();

		if (description) {
			setProjectDescription(description);
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setDescription(projectDescription);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectDescription]);

    const handleDetailsChange = (event) => {
        setProjectDescription(event.target.value);
    }

    return (
        <Fragment>
            <FormGroup className="cont-textarea">
                <Input
                    id="project-details"
                    name="project_details"
                    type="textarea"
                    placeholder="Enter a short description of your project scope"
                    onChange={handleDetailsChange}
                    value={projectDescription}
                />
                <Label for="project-details">
                    <span className="text-label">e.g. Remodeling our entire bathroom. Replacing toilet, sink, bathtub and door. New tiles on floor and around bathtub"</span>
                </Label>
            </FormGroup>
        </Fragment>
    );
}

export default Description;